module.exports = __webpack_public_path__ + "static/media/Group 26.4748ffca.svg";